/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 1ae6e2d8 (Tue May  5 20:16:57 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
  CashAmount,
  CashAmountFromJSON,
  CashAmountToJSON,
  FetchDirectorFinancialDetailsResponseFamilies,
  FetchDirectorFinancialDetailsResponseFamiliesFromJSON,
  FetchDirectorFinancialDetailsResponseFamiliesToJSON,
} from './'

/**
 *
 * @export
 * @interface FetchDirectorFinancialDetailsResponseTutors
 */
export interface FetchDirectorFinancialDetailsResponseTutors {
  /**
   * Tutor's first name
   * @type string
   * @memberof FetchDirectorFinancialDetailsResponseTutors
   */
  firstName: string
  /**
   * Tutor's last name
   * @type string
   * @memberof FetchDirectorFinancialDetailsResponseTutors
   */
  lastName: string
  /**
   * Number of families supported by the tutor
   * @type number
   * @memberof FetchDirectorFinancialDetailsResponseTutors
   */
  enrollmentCount: number
  /**
   *
   * @type CashAmount
   * @memberof FetchDirectorFinancialDetailsResponseTutors
   */
  tutorOwesDirector: CashAmount
  /**
   *
   * @type CashAmount
   * @memberof FetchDirectorFinancialDetailsResponseTutors
   */
  familiesOweTutor: CashAmount
  /**
   * List of families supported by the tutor.
   * @type {Array<FetchDirectorFinancialDetailsResponseFamilies>}
   * @memberof FetchDirectorFinancialDetailsResponseTutors
   */
  families: Array<FetchDirectorFinancialDetailsResponseFamilies>
}

export function FetchDirectorFinancialDetailsResponseTutorsFromJSON(
  json: any
): FetchDirectorFinancialDetailsResponseTutors {
  return FetchDirectorFinancialDetailsResponseTutorsFromJSONTyped(json, false)
}

export function FetchDirectorFinancialDetailsResponseTutorsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FetchDirectorFinancialDetailsResponseTutors {
  if (json === undefined || json === null) {
    return json
  }
  return {
    firstName: json['firstName'],
    lastName: json['lastName'],
    enrollmentCount: json['enrollmentCount'],
    tutorOwesDirector: CashAmountFromJSON(json['tutorOwesDirector']),
    familiesOweTutor: CashAmountFromJSON(json['familiesOweTutor']),
    families: (json['families'] as Array<any>).map(
      FetchDirectorFinancialDetailsResponseFamiliesFromJSON
    ),
  }
}

export function FetchDirectorFinancialDetailsResponseTutorsToJSON(
  value?: FetchDirectorFinancialDetailsResponseTutors | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    firstName: value.firstName,
    lastName: value.lastName,
    enrollmentCount: value.enrollmentCount,
    tutorOwesDirector: CashAmountToJSON(value.tutorOwesDirector),
    familiesOweTutor: CashAmountToJSON(value.familiesOweTutor),
    families: (value.families as Array<any>).map(
      FetchDirectorFinancialDetailsResponseFamiliesToJSON
    ),
  }
}
